module.exports = __webpack_public_path__ + "img/1.10_Russian_road_sign.d5df689b.svg";